import React from 'react';
import {Layout } from 'antd';
import { Avatar, List } from 'antd';
import BondRepaymentCalculator from './bond-repayment/BondRepaymentCalculator';
import MortgageAffordabilityCalculator from './mortgage-affordability/MortgageAffordabilityCalculator';
import RentalYieldCalculator from './rental-yield/RentalYieldCalculator';
import WithLoanRentalYieldCalculator from './rental-yield/WithLoanRentialYieldCalculator';
import {useState, useEffect} from 'react';
import BreakEvenPointCalculator from './break-even-time/BreakEvenPointCalculator';

const {Header, Footer, Sider, Content} = Layout;

/*--- Style----*/

const menuStyle = {
    border: 'outset 1px',
    marginTop: 30,
    marginLeft: 20,
    marginRight: 20,
    padding: 20,
    borderRadius:10
}

const contentStyle = {
    minHeight: 120,
    color: '#000',
    backgroundColor: '#fff',
    marginBottom: 20
  };

const siderStyle = {
    /*textAlign: 'center',
    lineHeight: '120px',
    color: '#fff',*/
    backgroundColor: '#FFFFFF',
};

const menuData = [
    {
        tag: 'Rental Yield',
        title: 'Rental Yield Calculator',
        component: <RentalYieldCalculator/>
    },
    {
        tag: 'Break Even Time',
        title: 'Break Even Time Calculator',
        component: <BreakEvenPointCalculator/>
    },

];

const SellerCalculatorPage = function(){

const handleItemClick = (item)=>{
    setCalculator(menuData[item].component)//set calculator of interest
    setCalculatorTitle(menuData[item].title)
}

const [calculatorTitle, setCalculatorTitle] = useState(menuData[0].title)
const [calculator, setCalculator] = useState(menuData[0].component)

  

return(
    <Layout>
        <Sider width="25%" style={siderStyle}>

        <List
            style = {menuStyle}
            itemLayout="horizontal"
            dataSource={menuData}
            renderItem={(item, index) => (
            <List.Item onClick={() => handleItemClick(index)} >
                <List.Item.Meta
                    title={item.tag}
                />
            </List.Item>
            )}
            header={<h4 style={{color: '#1677ff'}}>Seller Calculators </h4>}
        />

        </Sider>

        <Content style={contentStyle}>
                <h2 style={{color: '#1677ff', textAlign:'center'}}> { calculatorTitle}</h2> 
                {calculator}
        </Content>
    </Layout>
)
}


export default SellerCalculatorPage;